import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { ENTITIES } from '../../consts';
import { messages } from '../../intl';
import { getCurrentExam } from '../../store/model/selectors';
import formatDate from '../../utils/formatDate';
import DataGrid from '../DataGrid';

const DetectedProcesses = () => {
	const intl = useIntl();
	const exam = useSelector(getCurrentExam);
	const rows = exam?.detectedProcesses ?? [];

	const columns = useMemo(() => {
		return [
			{
				field: 'name',
				headerName: intl.formatMessage(messages.processName),
				width: 300,
				type: 'string',
			},
			{
				field: 'firstSeen',
				headerName: intl.formatMessage(messages.firstSeen),
				width: 200,
				type: 'dateTime',
				valueGetter: (params) => new Date(params.row.firstSeen),
				renderCell: (params) => formatDate(params.value),
			},
			{
				field: 'lastSeen',
				headerName: intl.formatMessage(messages.lastSeen),
				width: 200,
				type: 'dateTime',
				valueGetter: (params) => new Date(params.row.lastSeen),
				renderCell: (params) => formatDate(params.value),
			},
			{
				field: 'count',
				headerName: intl.formatMessage(messages.detectionCount),
				width: 150,
				type: 'number',
				align: 'right',
				headerAlign: 'right',
			},
		];
	}, [intl]);

	const dataGridConfig = { columns, gridId: ENTITIES.EXAMS_DETECTED_PROCESSES, rows, getRowId: (row) => row.name };

	return (
		<Accordion
			defaultExpanded={false}
			elevation={3}
			sx={{
				'&::before': { display: 'none' },
				'& .MuiDataGrid-columnHeaders': {
					background: (theme) => theme.palette.primary.main,
					color: (theme) => theme.palette.secondary.main,
					'& .MuiSvgIcon-root': {
						fill: (theme) => theme.palette.primary.dark,
					},
				},
			}}
		>
			<AccordionSummary expandIcon={<ExpandMore />} sx={{ px: '20px' }}>
				<h2 style={{ margin: 0, fontWeight: 700, fontSize: '1.2rem' }}>
					{intl.formatMessage(messages.detectedProcesses)} ({rows.length})
				</h2>
			</AccordionSummary>
			<AccordionDetails sx={{ px: '20px', pb: '20px', pt: 0 }}>
				<div style={{ height: '40vh' }}>
					<DataGrid {...dataGridConfig} />
				</div>
			</AccordionDetails>
		</Accordion>
	);
};

export default DetectedProcesses;
